import React, { Component } from 'react';
import { View, StyleSheet, Animated } from 'react-native';
import { LinearGradient } from 'expo-linear-gradient';
import AppTheme from '../../AppTheme';
import AppStyles from '../../AppStyles';
import Colors from '../../utils/constants/AppColors';

export class AnimatedShimmer extends React.Component<any, any> {

  constructor(props) {
    super(props);
    this.state = {};
  }

  animatedWidth: any = new Animated.Value(0)
  animatedHeight: any = new Animated.Value(100)
  width = this.props.width ?? AppTheme.appWidth - 32
  // componentWillMount = () => {
  //   this.animatedWidth = new Animated.Value(0)
  //   this.animatedHeight = new Animated.Value(100)
  // }
  componentDidMount() {
    this.animatedBox()
  }

  animatedBox = () => {
    Animated.loop(
      Animated.sequence([
        Animated.delay(10),
        Animated.timing(this.animatedWidth, {
          toValue: this.width - 80,
          duration: 1000,
          useNativeDriver: true,
          isInteraction: false,
        })
      ])).start()
  }

  render() {
    const width = this.props.width ?? AppTheme.appWidth - 32
    const borderRadius = this.props.borderRadius ?? 12
    const animatedStyle = {
      left: this.animatedWidth, blur: 90,
      width: 75, height: this.props.height ?? '100%',
      borderRadius: borderRadius
    }
    const backgroundStye = {
      width: width, height: this.props.height,
      backgroundColor: Colors.grey.shimmerBg,
      borderRadius: borderRadius
    }
    return (
      <View style={[AppStyles.flexRowCenter,
      {
        width: this.props.width ?? AppTheme.appWidth,
        borderRadius: borderRadius
      }]}>
        <View style={backgroundStye}>
          <Animated.View style={animatedStyle}>
            <LinearGradient start={[0, 0]} end={[1, 0]}
              style={{ height: '100%', width: 75 }}
              colors={[
                Colors.grey.shimmerBg,
                Colors.grey.shimmer,
                Colors.grey.shimmerBg
              ]}>
            </LinearGradient>
          </Animated.View>
        </View>
      </View>
    )
  }
}

export class BackgroundShimmer extends React.Component<any, any> {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const borderTopLeftRadius = this.props.borderRadius ?? 0
    const borderTopRightRadius = this.props.borderRadius ?? 0
    const borderBottomLeftRadius = this.props.borderRadius ?? 0
    const borderBottomRightRadius = this.props.borderRadius ?? 0
    return (
      <View style={{
        width: this.props.width,
        height: this.props.height,
        marginTop: this.props.marginTop ?? 0,
        marginBottom: this.props.marginBottom ?? 0,
        marginHorizontal: this.props.marginHorizontal ?? 0,
        backgroundColor: this.props.backgroundColor ?? Colors.grey.shimmerBg,
        borderTopLeftRadius: this.props.borderTopLeftRadius ?? borderTopLeftRadius,
        borderTopRightRadius: this.props.borderTopRightRadius ?? borderTopRightRadius,
        borderBottomLeftRadius: this.props.borderBottomLeftRadius ?? borderBottomLeftRadius,
        borderBottomRightRadius: this.props.borderBottomRightRadius ?? borderBottomRightRadius,
      }} />
    )
  }
}
